import { Box } from '@mui/material'
import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const Container = styled(Box)`
  padding: 16px 20px;
  border-radius: 12px;
  background: #2b37970d;
  border: 1px solid #2b37971a;
`

export const TopRow = styled(Box)`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  cursor: pointer;
`

export const TitleColumn = styled(Box)`
  display: flex;
  flex-direction: column;
`

export const Title = styled(Box)`
  ${({ theme }) => css`
    font-size: 20px;
    font-weight: 700;
    color: ${theme.colors.secondary};
  `}
`

export const Subtitle = styled(Box)`
  ${({ theme }) => css`
    margin-top: 4px;
    font-size: 14px;
    color: ${theme.colors.gray[400]};
  `}
`

export const ToggleButton = styled(Box)`
  display: flex;
  align-items: center;
  cursor: pointer;
  padding-top: 4px;
`

export const WarningBox = styled(Box)`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    gap: 12px;
    margin-top: 16px;
    padding: 12px 16px;
    border-radius: 16px;
    border: 1px solid #f59e0b1a;
    background: #f59e0b1a;
    color: ${theme.colors.secondary};
    font-size: 14px;
  `}
`

export const WarningIconWrapper = styled(Box)`
  display: flex;
  color: #f59e0b;
`

export const ExpandedContent = styled(Box)`
  margin-top: 16px;
`

export const WeekHeader = styled(Box)`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
`

export const WeekHeaderIcon = styled(Box)`
  ${({ theme }) => css`
    display: flex;
    color: ${theme.colors.secondary};
  `}
`

export const WeekHeaderTexts = styled(Box)`
  display: flex;
  flex-direction: column;
`

export const WeekHeaderTitle = styled(Box)`
  ${({ theme }) => css`
    font-size: 16px;
    font-weight: 700;
    color: ${theme.colors.secondary};
  `}
`

export const WeekHeaderSubtitle = styled(Box)`
  ${({ theme }) => css`
    font-size: 13px;
    color: ${theme.colors.gray[400]};
  `}
`

export const AccountsList = styled(Box)`
  ${({ theme }) => css`
    border: 1px solid ${theme.colors.border.light};
    border-radius: 12px;
    background: ${theme.colors.lightest};
    overflow: hidden;
  `}
`

export const AccountRow = styled(Box)`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding: 12px 16px;

    &:not(:last-child) {
      border-bottom: 1px solid ${theme.colors.border.light};
    }
  `}
`

export const AccountInfo = styled(Box)`
  display: flex;
  align-items: center;
  gap: 12px;
`

export const AccountBadge = styled(Box)<{ background: string; color: string }>`
  ${({ background, color }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 8px;
    background: ${background};
    color: ${color};

    svg {
      width: 16px !important;
      height: 16px !important;
    }

    & > div {
      min-width: 16px !important;
    }
  `}
`

export const AccountLabel = styled(Box)`
  ${({ theme }) => css`
    font-size: 15px;
    color: ${theme.colors.secondary};
  `}
`

export const AccountInputWrapper = styled(Box)`
  width: 220px;
`

export const FooterActions = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 16px;
`
